export default __webpack_public_path__ + "5dc63aa9417ce08fa975d9b06f287db0.png";